import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "authForm_title" }
const _hoisted_2 = { class: "authForm_description" }
const _hoisted_3 = { class: "authForm_content" }
const _hoisted_4 = { class: "authForm_input" }
const _hoisted_5 = {
  key: 0,
  class: "authForm_input_error",
  "data-cy": "auth_email_error"
}
const _hoisted_6 = {
  key: 0,
  class: "authForm_preloader"
}

import AuthLayout from '@web/platform.v3/layouts/auth.vue'
import InputV3 from '@web/platform.v3/components/input.vue'
import AcButton from '@ui-kit/components/AcButton.vue'
import AcPreloader from '@ui-kit/components/AcPreloader.vue'
import AuthEnterWith from '@web/platform.v3/components/auth/enter-with.vue'

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import { useAuthCatchErrors } from '@web/platform.v3/composables/useAuthCatchErrors'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AuthEmailForm'
},
  __name: 'auth-email-form',
  setup(__props) {



const router = useRouter()
const store = useStore()
const email = ref('')
const isLoading = ref(false)
const error = ref<string>('')

const storedEmail = computed(() => store.getters['authV3/email'])
const isTimerActive = computed(() => store.getters['authV3/isTimerActive'])

const { catchError, queryError } = useAuthCatchErrors()

const handleContinue = async () => {
  if (isLoading.value) return
  isLoading.value = true
  error.value = ''
  queryError.value = ''
  if (storedEmail.value === email.value && isTimerActive.value) {
    store.commit('authV3/setNeedStartTimer', false)
    store.commit('authV3/setEmailStatus', 'code')
    return
  }

  try {
    await store.dispatch('authV3/requestEmailCode', email.value)
    store.commit('authV3/setNeedStartTimer', true)
    store.commit('authV3/setEmail', email.value)
    store.commit('authV3/setEmailStatus', 'code')
  } catch (e) {
    error.value = catchError(e)
  } finally {
    isLoading.value = false
  }
}

function handleEnterPhone () {
  store.commit('authV3/reset')
  router.replace({ name: 'login', query: { type: 'phone' } })
}

watch(storedEmail, () => {
  if (storedEmail.value) {
    email.value = storedEmail.value
  }
}, {
  immediate: true,
  once: true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, { class: "authForm" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('auth.form.titleEmail')), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('auth.form.descriptionEamil')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "authForm_form",
          onSubmit: _withModifiers(handleContinue, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(InputV3, {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              placeholder: _ctx.$t('auth.email'),
              label: "Email",
              type: "email",
              name: "email",
              "data-cy": "auth_email_input",
              required: ""
            }, null, 8, ["modelValue", "placeholder"]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(AcButton, {
              class: "authForm_button-continue",
              type: "submit",
              variant: "tonal",
              block: "",
              "data-cy": "auth_email_submit",
              disabled: !email.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isLoading.value ? _ctx.$t('auth.form.buttonSend') : _ctx.$t('continue')) + " ", 1),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(AcPreloader)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32),
        _createVNode(AuthEnterWith, { error: _unref(queryError) }, null, 8, ["error"]),
        _createVNode(AcButton, {
          variant: "text",
          color: "gray",
          class: "authForm_enter-phone",
          block: "",
          "data-cy": "auth_enter_by_phone",
          onClick: handleEnterPhone
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('auth.enterByPhone')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})